module.exports = __webpack_public_path__ + "img/badge-list-thumb-060.76ff5826.png";